module.exports = __webpack_public_path__ + "img/otp-transprarent-2@2x.c97d7cf6.png";